import React from 'react';

import {useUserStatuses} from 'src/hooks/dictionaries';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';

type Props = {
    accountId?: number,
    userStatus: string,
    availableStatuses: string[],
    setUserStatus: (status: string) => void,
    disabled?: boolean,
};

export const UserStatusSuggest = ({userStatus, availableStatuses, setUserStatus, disabled}: Props) => {
    const {getUserStatusByCode} = useUserStatuses();

    return (
        <ComboBox
            disabled={disabled || !availableStatuses || availableStatuses.length < 2}
            value={userStatus}
            onChange={setUserStatus}>
            {availableStatuses.map(statusCode => (
                <ComboboxItem
                    key={statusCode}
                    caption={getUserStatusByCode(statusCode)?.description || ''}
                    value={statusCode}
                />
            ))}
        </ComboBox>
    );
};
